import { Input, SegmentedControl, Switch } from '@platform/design-system';
import { usePageContext } from '../usePageContext.ts';
import { useLabelPreferences } from './label-preferences.ts';
import { LABEL_FORMATS, STICKERS_PER_SHEET, SYMBOLOGIES } from './labels.ts';
import styles from './Labels.module.css';

const clampStart = (value: number): number =>
  Number.isFinite(value) ? Math.min(STICKERS_PER_SHEET, Math.max(1, Math.trunc(value))) : 1;

export type LabelSettingsProps = { startAt: number; onStartAtChange: (startAt: number) => void };

export const LabelSettings = ({ startAt, onStartAtChange }: LabelSettingsProps) => {
  const { t } = usePageContext();
  const { format, symbology, showPrice, choose } = useLabelPreferences();
  return (
    <div className={styles['settings']}>
      <SegmentedControl
        label={t('labels.format')}
        segments={LABEL_FORMATS.map((value) => ({ value, label: t(`labels.format_${value}`) }))}
        value={format}
        onChange={(value) => {
          choose({ format: value });
        }}
      />
      <SegmentedControl
        label={t('labels.symbology')}
        segments={SYMBOLOGIES.map((value) => ({ value, label: t(`labels.symbology_${value}`) }))}
        value={symbology}
        onChange={(value) => {
          choose({ symbology: value });
        }}
      />
      <Switch
        label={t('labels.showPrice')}
        checked={showPrice}
        onChange={(event) => {
          choose({ showPrice: event.target.checked });
        }}
      />
      {format === 'sheet' ? (
        <Input
          className={styles['startAt']}
          type="number"
          inputMode="numeric"
          min={1}
          max={STICKERS_PER_SHEET}
          label={t('labels.startAt')}
          helperText={t('labels.startAtHelp', { count: STICKERS_PER_SHEET })}
          value={startAt}
          onChange={(event) => {
            onStartAtChange(clampStart(event.target.valueAsNumber));
          }}
        />
      ) : null}
    </div>
  );
};
